import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Pagination.module.css'

import ArrowLeft from './arrow-left-s-fill.svg'
import ArrowRight from './arrow-right-s-fill.svg'

const Stats = (props) => {
  const { currentPage, pageSize, totalItems = 0 } = props

  if (!currentPage || !pageSize) {
    return null
  }

  if (totalItems === 0) {
    return <div className={styles.Stats}>0 results</div>
  }

  const offset = currentPage * pageSize - pageSize + 1
  const limit = currentPage * pageSize > totalItems ? totalItems : currentPage * pageSize

  return (
    <div className={styles.Stats}>
      {offset}-{limit} of {totalItems}
    </div>
  )
}

const Pagination = (props) => {
  const { canPreviousPage, canNextPage, previousPage, nextPage } = props

  const handlePrevClick = () => {
    previousPage?.()
  }

  const handleNextClick = () => {
    nextPage?.()
  }

  return (
    <div className={styles.PaginationContainer}>
      <Stats {...props} />
      <div className={styles.Controls}>
        <div className={cx(styles.Previous, { [styles.Disabled]: !canPreviousPage })} onClick={handlePrevClick}>
          <ArrowLeft height='18' width='18' />
        </div>
        <div className={cx(styles.Next, { [styles.Disabled]: !canNextPage })} onClick={handleNextClick}>
          <ArrowRight height='18' width='18' />
        </div>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  /** Whether previous page is available or not */
  canNextPage: PropTypes.bool,
  /** Whether next page is available or not */
  canPreviousPage: PropTypes.bool,
  /** Fired when next button is clicked */
  nextPage: PropTypes.func,
  /** Fired when previous button is clicked */
  previousPage: PropTypes.func
}

Pagination.defaultProps = {
  canNextPage: false,
  canPreviousPage: false,
  nextPage: undefined,
  previousPage: undefined
}

export default Pagination
